import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Programme } from '../applicant/programme';
import { UrlSignature } from '../common/apiEndpoint';
import { Applicant } from '../applicant/applicant';

@Injectable()
export class ProgrammeSelectionService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getProgrammeList(): Observable<Programme[]> {
    const url = this.urlSignature.programmeListUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Programme[]));
  }

  getApplicantDetails(applicantId: string): Observable<Applicant> {
    const url = this.urlSignature.applicantUrl + applicantId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Applicant));
  }

  saveApplicant(applicant: Applicant, currentYear: string) {
    const url = this.urlSignature.applicantUrl;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    let data = this.createApplicantData(applicant, currentYear);
    return this.httpClient
      .post(url, data, httpOptions)
      .pipe(map((response) => response as Response));
  }

  createApplicantData(applicant: Applicant, currentYear: string) {
    let applicantData =
      '{' +
      '"applicantType": "' +
      applicant.applicantType +
      '",' +
      '"semester": "' +
      applicant.semester +
      '",' +
      '"applicationReceivedDate": "' +
      applicant.applicationReceivedDate +
      '",' +
      '"applicationStatus": "' +
      applicant.applicationStatus +
      '",' +
      '"bankDraftNumber": "' +
      applicant.bankDraftNumber +
      '",' +
      '"lastUpdate": "' +
      applicant.lastUpdate +
      '",' +
      '"personId": "' +
      applicant.personId +
      '",' +
      '"programmeId": "' +
      applicant.programmeId +
      '",' +
      '"programmeTypeId": "' +
      applicant.programmeTypeId +
      '",' +
      '"registrationNumber": "' +
      applicant.registrationNumber +
      '",' +
      '"sessionId": "' +
      applicant.sessionId +
      '",' +
      '"year": "' +
      currentYear +
      '"' +
      '}';
    return applicantData;
  }
}
